export const mutations = {
  addParkingitems(state) {
    state.parking_items.push({
      description: "PARKING FEE",
      truck_id: "",
      unit_price: "",
      total_price: ""
    });
  },

  STORE_PARKINGS(state, parkings) {
    state.parkings = parkings;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/parkings/mutations.js